import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { map, Observable } from "rxjs";
import { Effort } from "../models/effort";
import { ProjectsService } from "../services/projects.service";
import { Project } from "../models/project";

@Injectable()
export class ProjectsResolver  {
    constructor(
        private router: Router,
        private projectService: ProjectsService,
        private http: HttpClient)
    {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Project[]> {
        const p = route.queryParams;
        const filter = p["filter.effort.id"] ? [ { chip: 'effortId', value: p["filter.effort.id"] } ] : [];
        return this.projectService.filterProjects(filter).pipe(map(p => p.projects));;
    }
}